import { Image } from 'app/src/shared/components'
import { Galleria } from 'primereact/galleria'
import type { ReactElement } from 'react'

export type ProductImageCarouselPropsType = {
  images: string[]
}

export function ProductImageCarousel(props: ProductImageCarouselPropsType): ReactElement {
  const itemTemplate = (imgSrc: string) => {
    return (
      <Image
        src={imgSrc}
        className='object-fit aspect-[3/2] max-h-[250px] max-w-[460px]'
        pt={{ image: { className: 'max-h-[250px]' } }}
        alt='Immagine esempio del prodotto'
        data-testid='hide-in-storybook'
      />
    )
  }

  return (
    <div className='card my-[4px] lg:my-[40px]'>
      <Galleria
        value={props.images}
        numVisible={5}
        circular
        style={{ maxWidth: '460px', maxHeight: '250px' }}
        showItemNavigators
        showItemNavigatorsOnHover
        showIndicators
        showThumbnails={false}
        item={itemTemplate}
        pt={{
          indicator: { className: props.images?.length > 1 ? 'custom-indicator' : 'hidden' },
          nextItemButton: { className: props.images?.length > 1 ? '' : 'hidden' },
          previousItemButton: { className: props.images?.length > 1 ? '' : 'hidden' },
          nextItemIcon: { className: 'text-[var(--primary-color)]' },
          previousItemIcon: { className: 'text-[var(--primary-color)]' },
        }}
      />
    </div>
  )
}
